import { ButtonBase } from "@mui/material";
import { useIntl } from "react-intl";

import { Button } from "@/components/Button/Button";
import { IconSupport, IconWhatsApp } from "@/components/Icons";
import { CaretRightIcon } from "@/components/Icons/rtlReadyIcons";
import { CommonTrackingEvents, rudderAnalytics } from "@/lib/rudderstack";
import { WHATSAPP_URL } from "@/utils/constants";

export function MainSearchWhatsAppBanner() {
  const intl = useIntl();

  return (
    <ButtonBase
      onClick={() =>
        rudderAnalytics.track(CommonTrackingEvents.USER_CONTACTED_SUPPORT)
      }
      href={WHATSAPP_URL}
      sx={{
        p: "calc(var(--spacing) * 3)",
        bgcolor: "var(--color-surface-base-light)",
        display: "flex",
        alignItems: "center",
        width: "100%",
        borderRadius: "var(--radius-2xl)",
        border: "1px solid var(--color-stroke-neutral-soft)",
      }}
    >
      <IconSupport className="m-2 me-3 size-8" />

      <span className="flex flex-col text-sm">
        <span className="font-medium text-black">
          {intl.formatMessage({
            defaultMessage: "Need help?",
            description:
              "Primary headline in the WhatsApp support banner on the search screen",
          })}
        </span>
        <span className="text-text-placeholder">
          {intl.formatMessage({
            defaultMessage: "Our team is here to help you!",
            description:
              "Secondary text in the WhatsApp support banner on the search screen",
          })}
        </span>
      </span>

      <CaretRightIcon className="ms-auto size-5 text-text-primary" />
    </ButtonBase>
  );
}

export function SearchResultsWhatsAppBanner() {
  const intl = useIntl();

  return (
    <div className="flex w-full flex-col gap-4 rounded-xl bg-white p-4 shadow-sm">
      <div className="flex items-center">
        <IconSupport className="m-2 me-3 size-9" />

        <span className="flex flex-col text-sm">
          <span className="font-medium text-black">
            {intl.formatMessage({
              defaultMessage: "Need help?",
              description:
                "Primary headline in the WhatsApp support banner on the search screen",
            })}
          </span>
          <span className="text-text-placeholder">
            {intl.formatMessage({
              defaultMessage: "Our team is here to help you!",
              description:
                "Secondary text in the WhatsApp support banner on the search screen",
            })}
          </span>
        </span>
      </div>

      <Button
        onClick={() => {
          rudderAnalytics.track(CommonTrackingEvents.USER_CONTACTED_SUPPORT);
        }}
        href={WHATSAPP_URL}
        variant="contained"
        borderRoundness="medium"
        color="whatsapp"
        fullWidth
        startIcon={<IconWhatsApp className="size-5" />}
      >
        {intl.formatMessage({
          defaultMessage: "Chat on WhatsApp",
          description: "Button label to open WhatsApp chat with support",
        })}
      </Button>
    </div>
  );
}
